
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[name]",
      function () {
        return require("private-next-pages/brands/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[name]"])
      });
    }
  